// extracted by mini-css-extract-plugin
export var content = "_ni-1";
export var fullScreen = "_ni-0";